import {
  Button,
  Grid,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { zsHeader, zsHeaderBg } from '@pages/lending/assets';
import ZERO_STATE_BENEFITS from '@pages/lending/constants/ZeroStateBenefits';
import { useTranslation } from 'react-i18next';
import { useIntercom } from 'react-use-intercom';

const EmptySate = () => {
  const { showNewMessage } = useIntercom();
  const { t } = useTranslation();
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={9} className="!text-center">
          <div className="max-w-[900px] mx-auto">
            <div className="bg-[#E8F3FF] rounded-tr-xl rounded-tl-xl">
              <div className="flex flex-row px-8 py-5 relative">
                <div className="flex flex-col items-start justify-center gap-2 text-left">
                  <Typography variant="h6" className="font-semibold">
                    {t('ldZsHeader')}
                  </Typography>
                  <Typography variant="body1" className="text-slate-600">
                    {t('ldZsDescription')}
                  </Typography>
                  <Button
                    variant="contained"
                    className="!bg-[#016bf8] !text-white !mt-4 !normal-case"
                    onClick={() => {
                      showNewMessage(t('ldIntercomMessage') as string);
                    }}
                  >
                    {t('ldZsAction')}
                  </Button>
                </div>
                <img
                  className="h-[200px] w-auto z-50"
                  src={zsHeader}
                  alt="Zero state header"
                />
                <img
                  className="h-full w-auto z-0 absolute top-0 right-0"
                  src={zsHeaderBg}
                  alt="Zero state header"
                />
              </div>
            </div>
            <Grid container>
              {ZERO_STATE_BENEFITS.map((item) => (
                <Grid
                  key={item.description}
                  item
                  xs={12}
                  lg={3}
                  className="border-[#EBF3FA] border-solid border p-3 text-left"
                >
                  {item.icon}
                  <Typography variant="body2">{t(item.description)}</Typography>
                </Grid>
              ))}
            </Grid>
          </div>
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

export default EmptySate;
